import React, { useCallback, useEffect, useState } from 'react';
import { apiGet } from '../lib/api';
import { Badge } from '../lib/badge';
import Icon from '../components/icons';
import { EmptyState } from './ListView';
import ClaudeOutputModal from '../components/ClaudeOutputModal';

export default function Runs() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const [selected, setSelected] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setErr('');
    apiGet('/orchestration-runs?limit=100')
      .then((data) => setRows(Array.isArray(data) ? data : []))
      .catch((e) => setErr(String(e)))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <main className="page">
      <div className="page__header page__header--split">
        <div className="page__header-row">
          <span className="page__icon"><Icon name="runs" /></span>
          <div className="page__header-text">
            <h2>Skill Runs</h2>
            <p>Orchestration runs from the Claude skill worker — open any row to read the model output.</p>
          </div>
        </div>
        <div className="page__header-actions">
          <button type="button" className="btn-secondary btn-small" onClick={load} disabled={loading}>
            <Icon name="refresh" /> {loading ? 'Loading…' : 'Refresh'}
          </button>
        </div>
      </div>

      {err && <div className="status status--error">{err}</div>}

      <section className="panel">
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Run</th>
                <th>Task</th>
                <th>Workspace</th>
                <th>Skill</th>
                <th>Status</th>
                <th>Credits</th>
                <th>Created</th>
                <th>Output</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={8} className="table-loading">Loading runs…</td></tr>
              )}
              {!loading && rows.length === 0 && (
                <tr><td colSpan={8}><EmptyState label="No orchestration runs yet." /></td></tr>
              )}
              {!loading && rows.map((r) => (
                <tr key={r.id}>
                  <td className="cell-strong">#{r.id}</td>
                  <td className="cell-truncate" title={r.task_title || ''}>
                    #{r.task_id}{r.task_title ? ` · ${r.task_title}` : ''}
                  </td>
                  <td className="cell-muted">{r.workspace_name || '—'}</td>
                  <td>{r.skill_key || '—'}</td>
                  <td><Badge value={r.status} /></td>
                  <td className="cell-muted">{r.credits_used ?? '—'}</td>
                  <td className="cell-muted">{r.created_at ? new Date(r.created_at).toLocaleString() : '—'}</td>
                  <td>
                    <button
                      type="button"
                      className={`btn-small ${r.has_output ? 'btn-primary' : 'btn-secondary'}`}
                      onClick={() => setSelected(r)}
                    >
                      {r.has_output ? 'View output' : 'Details'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {selected && (
        <ClaudeOutputModal
          title={`Run #${selected.id} · Task #${selected.task_id}${selected.task_title ? ` · ${selected.task_title}` : ''}`}
          run={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </main>
  );
}
